import { render, staticRenderFns } from "./LatestTurns.vue?vue&type=template&id=abb3fd14&scoped=true"
import script from "./LatestTurns.vue?vue&type=script&lang=js"
export * from "./LatestTurns.vue?vue&type=script&lang=js"
import style0 from "./LatestTurns.vue?vue&type=style&index=0&id=abb3fd14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb3fd14",
  null
  
)

export default component.exports